<template>
  <div>
  <div class="content">

    <b-container fluid class="mt-4">
    
      <stats-card title="Roles" type="default" sub-title="All roles" icon="fas fa-shield-alt">

        <template slot="actions">
            <a class="dropdown-item" href="/#/access/roles/create" @click="showCreateModal = true">Create new</a>
        </template>

        <template slot="append">

          <!-- <base-alert>
            Last {{tableOptions.limit}} roles created displayed here. Use the search bar below to fetch more.
          </base-alert> -->

          <div class="mt-4">
            <entity-picker v-if="rolesData.length > 0"
                :canEdit="true"
                :canSelect="false"
                placeHolder="Start typing something..."
                apiEndpoint="getRoles"
                :selected="rolesData"
                :cursorData="cursorData"
                editPath="/access/roles/"
                :tableColumns= tableColumns
                :filters="userFilters"
                rootProp="roles"
                :tableOptions="tableOptions"
            >
            </entity-picker>
          </div>
              
        </template>
      </stats-card>
    </b-container>
  </div>

  
  </div>
</template>


<script>
import api from '@/api'
import { tableColumns, tableFilters, tableOptions } from '@/config/RoleTable'
import BaseAlert from '../components/BaseAlert.vue';

export default {
  components: {
    BaseAlert
  },
  data() {
    return {
      tableColumns: tableColumns,
      userFilters: tableFilters,
      tableOptions: tableOptions,
      createActivate: true,
      createDefault: false,
      rolesData: [],
      cursorData: null,
      selectedRows: [],
    };
  },
  created: async function() {
    this.$emit('loading', true);
    const results = await api.getRoles({
      sort: this.tableOptions['default-sort'].prop,
      direction: this.tableOptions['default-sort'].order == 'ascending' ? 'asc' : 'desc',
      limit: this.tableOptions.limit
    })
    this.$emit('loading', false);
    this.rolesData = results.roles;
    this.cursorData = results.cursor
  },
  methods: {
  }
};
</script>
